import './app';


/**
 * Importing the app images
 */
require.context('./assets/fonts', true, /^\.\//);
require.context('./assets/images', true, /^\.\//);



// WEBPACK FOOTER //
// ./src/index.js